import { useMemo, FC } from 'react'
import { isEqual } from 'lodash'

import { Alert } from 'ui'
import { getBreaksToApply } from 'services/schedule'
import { t } from 'translations'

type Props = {
  values: MData.Event
  initialValues: { start: string; end: string }
  setFieldValue: (field: string, value: Partial<MData.Break>[]) => void
}

const AutoRecalculateBreaks: FC<Props> = ({ values, initialValues, setFieldValue }) => {
  const { start, end, positionId, breaks } = values
  const newBreaks = useMemo(() => getBreaksToApply({ start, end }, positionId), [start, end, positionId])

  if ((start === initialValues.start && end === initialValues.end) || isEqual(newBreaks, breaks)) return null

  return (
    <Alert variant="warning">
      <Alert.Action onClick={() => setFieldValue('breaks', newBreaks)}>{t('manager.schedule.eventForm.TIME_CHANGED_RECALCULATE_BREAKS')}</Alert.Action>
    </Alert>
  )
}

export default AutoRecalculateBreaks
